import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding recap #42: HackerNews app where people are nice",
  "description": "",
  "published": "2017-07-10T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-recap-42-hackernews-app-where-people-nice/swizec/7701"],
  "categories": "Livecoding, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding. Usually shorter than 500 words. Often with pictures. Livecoding happens almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{` on multiple channels. You should follow `}<a parentName="em" {...{
          "href": "https://www.youtube.com/TheSwizec"
        }}>{`My Youtube`}</a>{` channel to catch me live.`}</em></p>
    <p>{`This weekend, I tried something new: Coding from a pleasant sunny location. It didn't go so well.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/07/swiz-face.png",
        "alt": null
      }}></img></p>
    <p>{`First, the internet was atrocious. My stream kept lagging and cutting off and being blurry. In the end, I had to crank the bitrate and resolution way down. That helped, sort of.`}</p>
    <p>{`Second, YouTube blocked my video based on copyright. Listening to music through your monitor and recording it as a background murmur through your mic is okay. Listening through laptop and using the built-in mic is not okay.`}</p>
    <p><em parentName="p">{`shrug`}</em></p>
    <p>{`Third, I got sunburnt on half of my face. `}<strong parentName="p">{`BUT`}</strong>{` new MacBook Pro screens work in sunlight! You can actually see the screen now 😁`}</p>
    <p>{`Fourth, my girlfriend decided it would be funny to water me like a plant. It was not. 😒`}</p>
    <p>{`The good news is YouTube offers a "remove song" feature, so I might be able to salvage this video. We'll see.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/07/YT-screenshot.png",
        "alt": null
      }}></img></p>
    <lite-youtube {...{
      "videoid": "nHsPzNz8MW4",
      "videostartat": "0"
    }}></lite-youtube>
    <lite-youtube {...{
      "videoid": "Z2GDx8PAwkc",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Yes, two livecoding sessions last week. :)`}</p>
    <p>{`I didn't finish the app while streaming. There's going to be a full tutorial and proper edited video on `}<a parentName="p" {...{
        "href": "http://school.shoutem.com/"
      }}>{`React Native School`}</a>{` later this week.`}</p>
    <p>{`So what was I even building?`}</p>
    <p>{`One of those HackerNews App projects. You know the type; it's not quite a TODO app, but it's similarly generic and a common example to show people how things are done.`}</p>
    <p>{`Mine's going to have a twist though: It’s gonna hide comments and stories where `}<a parentName="p" {...{
        "href": "https://cloud.google.com/natural-language/"
      }}>{`semantic analysis`}</a>{` says people aren't being nice.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Tutorial idea: building a Hacker News clone where people are nice`}</p>{`— Dan (@dan_abramov) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/dan_abramov/status/882757021124235264"
      }}>{`July 6, 2017`}</a></blockquote>
    <p>{`I think it's going to work.`}</p>
    <p>{`I ran some positive and negative comments through Google Cloud's Natural Language API, and it looks promising. Bad comments get a negative score, good comments are positive, most are neutral.`}</p>
    <p>{`It's not as good as their `}<a parentName="p" {...{
        "href": "https://www.perspectiveapi.com/#/"
      }}>{`Perspective API`}</a>{` promises to be. Unlike Perspective, it's already here and should work as a proof of concept.`}</p>
    <p>{`Plan is to have the app finished tonight and a full tutorial out by Wednesday.`}</p>
    <p>{`The trickiest part is convincing React Native to render HackerNews comments because they're in HTML. Guess what doesn't automatically render in a native app? That's right… HTML.`}</p>
    <p>{`There's Webviews, but I'm not sure how I feel about those. Feels hamfisted for text that only does italics, quotes, and links.`}</p>
    <p>{`Some htmltext components do exist, but they're old. Might have to roll my own.`}</p>
    <p>{`We'll see.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      